import React from "react";
import { PaystackButton } from "react-paystack";
import { toast } from "react-toastify";
import { secureStorage } from "./utils/secureStorage";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const PaystackCheckout = ({
  userEmail,
  userName,
  userPhone,
  planAmount,
  selectedPlanName,
  orgId,
  orgName,
  durationMonths = 1,
  isUserTopup = false,
}) => {
  const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;
  const amount = planAmount * 100; // Convert to kobo

  // const fetchUpdatedOrgInfo = async () => {
  //   try {
  //     const res = await fetch(`${API_BASE_URL}/organization/${orgId}`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     });
  //     if (!res.ok) throw new Error("Failed to fetch organization info");
  //     const orgData = await res.json();

  //     localStorage.setItem("organization_name", orgData.name);
  //     localStorage.setItem("tier", orgData.tier.name);
  //     localStorage.setItem("max_users", orgData.tier.max_users);

  //     toast.success(`✅ Plan upgraded to ${selectedPlanName}`);
  //     // You can trigger UI refresh here if needed
  //   } catch (error) {
  //     toast.error("❌ Failed to refresh organization info");
  //     console.error(error);
  //   }
  // };

  const pollForOrgUpdate = async (maxTries = 10, delay = 2000) => {
    for (let i = 0; i < maxTries; i++) {
      try {
        const res = await fetch(`${API_BASE_URL}/organization/${orgId}`, {
          headers: {
            Authorization: `Bearer ${secureStorage.getItem("token")}`,
          },
        });
        const orgData = await res.json();
  
        const accessExpiresAt = orgData.access_expires_at;
  
        if (accessExpiresAt && new Date(accessExpiresAt) > new Date()) {
          // Update localStorage
          secureStorage.setItem("organization_name", orgData.name);
          secureStorage.setItem("tier", orgData.tier.name);
          secureStorage.setItem("max_users", orgData.max_users);
          secureStorage.setItem("accessExpiresAt", orgData.access_expires_at);
          
  
          toast.success(`✅ Plan activated`);
          window.location.reload(); // Safe reload
          return;
        }
      } catch (e) {
        console.warn("Polling failed, retrying...");
      }
  
      await new Promise((res) => setTimeout(res, delay));
    }
  
    toast.error("❌ Upgrade not confirmed. Please try again or contact support.");
  };
  

  const handleSuccess = () => {
    pollForOrgUpdate();
    // fetchUpdatedOrgInfo();
    // window.location.reload(); // Safe reload
  };

  const handleClose = () => {
    toast.warning("❌ Payment dialog closed");
  };

  const componentProps = {
    email: userEmail,
    amount,
    metadata: {
      name: userName,
      phone: userPhone,
      organization_id: orgId,
      organization_name: orgName,
      tier_name: selectedPlanName,
      duration_months: durationMonths,
      isUserTopup: isUserTopup.toString(),
    },
    publicKey,
    text: "Pay Now",
    onSuccess: handleSuccess,
    onClose: handleClose,
  };

  return (
    <div>
      <PaystackButton className="paystack-button" {...componentProps} />
    </div>
  );
};

export default PaystackCheckout;


